import React from 'react';
import { PaymentOptions } from '@wix/ambassador-pricing-plans-read-api/http';
import { useTranslation, useEnvironment } from 'yoshi-flow-editor-runtime';

import { st, classes } from './Recurrence.st.css';
import { getPeriodLabel } from '../../../../../utils';
import { NO_BREAK_SPACE } from '../../../../../constants';

interface Props {
  paymentOptions?: PaymentOptions;
  recurringPlansExist: boolean;
  highlighted: boolean;
}

export const Recurrence: React.FC<Props> = ({ paymentOptions, recurringPlansExist, highlighted }) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();

  if (!recurringPlansExist) {
    return null;
  }

  return (
    <span className={st(classes.frequency, { highlighted, mobile: isMobile })}>
      {paymentOptions?.recurring ? getPeriodLabel(paymentOptions?.validFor, t) : NO_BREAK_SPACE}
    </span>
  );
};
